export const EMPTY_VALUE = '-'
export const RECOMMENDATIONS_ANCHOR = 'recommendations'
export const AI_RISK_REPORT_EXPORT_ERROR_TYPE = 'AI_RISK_REPORT_EXPORT'
export const AI_RISK_REPORT_PDF_CHUNK_ATTRIBUTE = 'data-ai-risk-report-pdf-chunk'
export const AI_RISK_REPORT_PDF_CHUNK_VALUE = 'true'
export const AI_RISK_REPORT_PDF_CHUNK_SELECTOR = `[${AI_RISK_REPORT_PDF_CHUNK_ATTRIBUTE}="${AI_RISK_REPORT_PDF_CHUNK_VALUE}"]`
export const AI_RISK_REPORT_PDF_CHUNK_ATTRIBUTES = {
  [AI_RISK_REPORT_PDF_CHUNK_ATTRIBUTE]: AI_RISK_REPORT_PDF_CHUNK_VALUE,
}
export const AI_RISK_REPORT_PDF_KEEP_WITH_NEXT_ATTRIBUTE = 'data-ai-risk-report-pdf-keep-with-next'
export const AI_RISK_REPORT_PDF_KEEP_WITH_NEXT_VALUE = 'true'
export const AI_RISK_REPORT_PDF_KEEP_WITH_NEXT_SELECTOR = `[${AI_RISK_REPORT_PDF_KEEP_WITH_NEXT_ATTRIBUTE}="${AI_RISK_REPORT_PDF_KEEP_WITH_NEXT_VALUE}"]`
export const AI_RISK_REPORT_PDF_KEEP_WITH_NEXT_ATTRIBUTES = {
  [AI_RISK_REPORT_PDF_KEEP_WITH_NEXT_ATTRIBUTE]: AI_RISK_REPORT_PDF_KEEP_WITH_NEXT_VALUE,
}
export const AI_RISK_REPORT_PDF_KEEP_CHUNK_WITH_NEXT_ATTRIBUTES = {
  ...AI_RISK_REPORT_PDF_CHUNK_ATTRIBUTES,
  ...AI_RISK_REPORT_PDF_KEEP_WITH_NEXT_ATTRIBUTES,
}
export const AI_RISK_REPORT_PDF_PAGE_BREAK_PROTECTED_ATTRIBUTE = 'data-ai-risk-report-pdf-page-break-protected'
export const AI_RISK_REPORT_PDF_PAGE_BREAK_PROTECTED_VALUE = 'true'
export const AI_RISK_REPORT_PDF_PAGE_BREAK_PROTECTED_SELECTOR = `[${AI_RISK_REPORT_PDF_PAGE_BREAK_PROTECTED_ATTRIBUTE}="${AI_RISK_REPORT_PDF_PAGE_BREAK_PROTECTED_VALUE}"]`
export const AI_RISK_REPORT_PDF_PAGE_BREAK_PROTECTED_ATTRIBUTES = {
  [AI_RISK_REPORT_PDF_PAGE_BREAK_PROTECTED_ATTRIBUTE]: AI_RISK_REPORT_PDF_PAGE_BREAK_PROTECTED_VALUE,
}

export const TONE = {
  OK: 'ok',
  WARN: 'warn',
  DANGER: 'danger',
  NEUTRAL: 'neutral',
  INFO: 'info',
}

export const COPILOT_ELIGIBILITY = {
  WITH_ADDON: 'eligible_with_addon',
  WITHOUT_ADDON: 'eligible_without_addon',
  NOT_ELIGIBLE: 'not_eligible',
}

export const STATUS_BADGE_VARIANT_BY_TONE = {
  [TONE.OK]: 'success',
  [TONE.WARN]: 'warning',
  [TONE.DANGER]: 'danger',
  [TONE.INFO]: 'info',
  [TONE.NEUTRAL]: 'secondary',
}

export const BAND_LABEL_ID_BY_TONE = {
  [TONE.OK]: 'AI_RISK_REPORT.BAND.STRONG',
  [TONE.WARN]: 'AI_RISK_REPORT.BAND.MODERATE',
  [TONE.DANGER]: 'AI_RISK_REPORT.BAND.GAPS',
  [TONE.NEUTRAL]: 'AI_RISK_REPORT.BAND.NOT_ASSESSED',
}

export const SCORE_IDS = {
  IDENTITY_ACCESS: 'score.identity_access',
  CONDITIONAL_ACCESS: 'score.conditional_access',
  APPS_OAUTH: 'score.apps_oauth',
  DATA_GOVERNANCE: 'score.data_governance',
  COPILOT_DATA_EXPOSURE: 'score.copilot_data_exposure',
  GROUP_GOVERNANCE: 'score.group_governance',
  DEVICE_COMPLIANCE: 'score.device_compliance',
  LICENSING: 'score.licensing',
}

export const DATA_KEYS = {
  APP_REGISTRATIONS: 'app_registration',
  AUTHORIZATION_POLICY: 'authorization_policy',
  ENTERPRISE_APPS: 'enterprise_apps',
  GROUP_EXPIRY_POLICY: 'group_expiry_policy',
  GUEST_USERS: 'guest_users',
  SHAREPOINT_SITES: 'sharepoint_sites',
  SHAREPOINT_PERMISSIONS: 'sharepoint_permissions',
  SENSITIVITY_LABELS: 'sensitivity_labels',
  AUTO_LABELLING_POLICIES: 'auto_labelling_policies',
  DLP_POLICIES: 'dlp_policies',
  RETENTION_POLICIES: 'retention_policies',
  MANAGED_DEVICES: 'managed_devices',
  MFA_REGISTRATION: 'mfa_registration',
  RESTRICTED_SHAREPOINT_SEARCH: 'restricted_sharepoint_search',
  EXTERNAL_CONNECTIONS: 'external_connections',
  COPILOT_STUDIO_AGENTS: 'copilot_studio_agents',
}

export const PRODUCTIVITY_HOURS_PER_USER_PER_WEEK = 2.4

const TONE_BY_STATUS = {
  ready: TONE.OK,
  needs_work: TONE.WARN,
  partial: TONE.WARN,
  not_ready: TONE.DANGER,
  not_assessed: TONE.NEUTRAL,
  not_applicable: TONE.NEUTRAL,
}

export const getToneFromStatus = (status) => TONE_BY_STATUS[status] ?? TONE.NEUTRAL

export const getToneFromScore = (score) => {
  if (score === null || score === undefined) return TONE.NEUTRAL
  if (score >= 75) return TONE.OK
  if (score >= 50) return TONE.WARN
  return TONE.DANGER
}
